'use strict';

import _slicedToArray from "/Users/emiliano/Development/marketingv2/packages/forestapanama/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useState, useEffect } from 'react';

var useScreenType = function useScreenType() {
  var _useState = useState(getScreenType()),
      _useState2 = _slicedToArray(_useState, 2),
      screenType = _useState2[0],
      setScreenType = _useState2[1];

  var resizeEvent = function resizeEvent() {
    setScreenType(getScreenType());
  };

  useEffect(function () {
    window.addEventListener('resize', resizeEvent);
    return function () {
      window.removeEventListener('resize', resizeEvent);
    };
  }, []);
  return screenType;
};

var getScreenType = function getScreenType() {
  var screenType = null;

  if (typeof window !== 'undefined') {
    if (window.matchMedia('(max-width: 575px)').matches) {
      screenType = 'xSmall';
    } else if (window.matchMedia('(max-width: 767px)').matches) {
      screenType = 'small';
    } else if (window.matchMedia('(max-width: 991px)').matches) {
      screenType = 'medium';
    } else if (window.matchMedia('(max-width: 1199px)').matches) {
      screenType = 'large';
    } else {
      screenType = 'xLarge';
    }
  }

  return screenType;
};

export default useScreenType;